












import Vue from "vue";
import Component from "vue-class-component";
import NavBar from "@/components/NavBar.vue";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component({
  components: { NavBar }
})
export default class App extends Vue {
  title = "";
  backRoute = "";

  // async created() {
  //   updateGTMGlobalVariables(this);
  // }
}
